const currentDate = new Date();

const currentYear = currentDate.getFullYear();

export const lastYear = currentYear - 1;

const firstSeptemberDate = new Date(`September 1, ${currentYear} 00:00:00`);

export const isBeforeSeptember = currentDate < firstSeptemberDate;
